<section class="login-block d-flex align-items-center">
  <div class="container-fluid">
      <div class="row d-flex justify-content-center">
        <img src="assets/images/log111.png" alt="logo.png">
      </div>
      <div class="row">
          <div class="col-sm-12">
            <div class="page-header card">
              <div class="row align-items-end">
                  <div class="col-lg-12">
                      <div class="page-header-title text-center">
                          <div class="d-inline">
                              <h5 class="text-center">Forgot Password</h5>
                              <span class="text-center text-danger">Please submit the username of the account.</span>
                          </div>
                      </div>
                  </div>
              </div>
          </div>

          <div class="pcoded-inner-content">
              <div class="main-body">
                  <div class="page-wrapper">
                      <div class="page-body">

                          <div class="row">
                              <div class="col-sm-3"></div>
                              <div class="col-sm-6">

                                  <div class="card">
                                      <div class="card-header text-center">
                                          <h5>Forgot Password</h5>
                                      </div>
                                      <div class="card-block">
                                          <form>
                                              <div class="form-group row">
                                                  <label class="col-sm-3 col-form-label">Username</label>
                                                  <div class="col-sm-9">
                                                      <input type="text" [(ngModel)]="username" name="username" required class="form-control">
                                                  </div>
                                              </div>

                                              <button class="btn btn-mat waves-effect waves-light btn-inverse   float-right" [disabled]="!username" (click)="onSubmitUsername()">Validate</button>

                                          </form>
                                      </div>
                                  </div>


                              </div>
                              <div class="col-sm-3"></div>
                          </div>

                      </div>
                  </div>
              </div>
          </div>
          </div>

      </div>

  </div>
</section>
